import React from "react";
import { Link } from "react-router-dom";

const CourseCategoryList: React.FC = () => {
  const categories = [
    {
      title: "Business & Management",
      img: "https://www.growniverse.com/images//Business.webp",
      accent: "#00f6ff",
    },
    {
      title: "Health & Nutrition",
      img: "https://www.growniverse.com/images//Health.webp",
      accent: "#8b5cff",
    },
    {
      title: "IT & Software",
      img: "https://www.growniverse.com/images//it.webp",
      accent: "#00f6ff",
    },
    {
      title: "Personality Development",
      img: "https://www.growniverse.com/images//Personality.webp",
      accent: "#8b5cff",
    },
    {
      title: "Share Market & Crypto Currency",
      img: "https://www.growniverse.com/images//ShareMarket.webp",
      accent: "#00f6ff",
    },
    {
      title: "Communication & Presentation Skills",
      img: "https://www.growniverse.com/images//Communication.webp",
      accent: "#8b5cff",
    },
    {
      title: "IELTS & English Speaking",
      img: "https://www.growniverse.com/images//IELETS.webp",
      accent: "#00f6ff",
    },
    {
      title: "LAW Management",
      img: "https://www.growniverse.com/images//Law.webp",
      accent: "#8b5cff",
    },
    {
      title: "Life Skills",
      img: "https://www.growniverse.com/images//LikeSkills.webp",
      accent: "#00f6ff",
    },
    {
      title: "Money Management",
      img: "https://www.growniverse.com/images//MoneyManagement.webp",
      accent: "#8b5cff",
    },
  ];

  return (
    <section
      style={{
        position: "relative",
        width: "100%",
        overflow: "hidden",

        padding: "80px 20px",

        background:
          "linear-gradient(135deg, #050810 0%, #080d19 50%, #050812 100%)",

        borderTop:
          "1px solid rgba(0,246,255,0.10)",

        borderBottom:
          "1px solid rgba(139,92,255,0.12)",

        boxShadow:
          "inset 0 1px 0 rgba(255,255,255,0.02), 0 20px 70px rgba(0,0,0,0.4)",
      }}
    >
      {/* =========================================================
          BACKGROUND GRID
      ========================================================= */}

      <div
        style={{
          position: "absolute",
          inset: 0,
          pointerEvents: "none",

          opacity: 0.055,

          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.08) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.08) 1px, transparent 1px)",

          backgroundSize: "38px 38px",
        }}
      />

      {/* =========================================================
          LEFT CYAN GLOW
      ========================================================= */}

      <div
        style={{
          position: "absolute",

          width: "500px",
          height: "500px",

          left: "-280px",
          top: "-220px",

          borderRadius: "50%",

          background:
            "rgba(0,246,255,0.07)",

          filter: "blur(120px)",

          pointerEvents: "none",
        }}
      />

      {/* =========================================================
          RIGHT PURPLE GLOW
      ========================================================= */}

      <div
        style={{
          position: "absolute",

          width: "500px",
          height: "500px",

          right: "-280px",
          bottom: "-250px",

          borderRadius: "50%",

          background:
            "rgba(139,92,255,0.08)",

          filter: "blur(120px)",

          pointerEvents: "none",
        }}
      />

      {/* =========================================================
          CONTENT
      ========================================================= */}

      <div
        style={{
          position: "relative",
          zIndex: 2,

          width: "100%",
          maxWidth: "1250px",

          margin: "0 auto",
        }}
      >
        {/* =======================================================
            SECTION HEADING
        ======================================================= */}

        <div
          style={{
            textAlign: "center",

            maxWidth: "850px",

            margin:
              "0 auto 50px",
          }}
        >
          {/* Small futuristic label */}

          <div
            style={{
              display: "inline-flex",

              alignItems: "center",

              gap: "9px",

              padding:
                "7px 16px",

              marginBottom:
                "18px",

              borderRadius:
                "30px",

              border:
                "1px solid rgba(0,246,255,0.18)",

              background:
                "rgba(0,246,255,0.035)",

              color: "#8fa6bd",

              fontSize: "10px",

              fontWeight: 700,

              letterSpacing:
                "2px",

              textTransform:
                "uppercase",
            }}
          >
            <span
              style={{
                width: "6px",
                height: "6px",

                borderRadius: "50%",

                background:
                  "#00f6ff",

                boxShadow:
                  "0 0 10px #00f6ff",
              }}
            />

            Explore Your Potential
          </div>

          {/* Main title */}

          <h2
            style={{
              margin:
                "0 0 18px",

              color:
                "#ffffff",

              fontSize:
                "clamp(30px, 5vw, 48px)",

              lineHeight: 1.15,

              fontWeight: 800,

              letterSpacing:
                "-0.8px",

              textShadow:
                "0 2px 15px rgba(0,0,0,0.8), 0 0 25px rgba(0,246,255,0.08)",
            }}
          >
            Choose Your Next Step{" "}
            <span
              style={{
                color:
                  "#00f6ff",

                textShadow:
                  "0 0 18px rgba(0,246,255,0.35)",
              }}
            >
              to Success
            </span>
          </h2>

          {/* Divider */}

          <div
            style={{
              width: "90px",
              height: "2px",

              margin:
                "0 auto 24px",

              background:
                "linear-gradient(90deg, #00f6ff, #8b5cff)",

              boxShadow:
                "0 0 12px rgba(0,246,255,0.35)",
            }}
          />

          {/* Description */}

          <p
            style={{
              margin: 0,

              color:
                "#b8c5d4",

              fontSize:
                "15px",

              lineHeight:
                1.8,

              fontWeight: 400,

              textShadow:
                "0 1px 7px rgba(0,0,0,0.8)",
            }}
          >
            The World need Dreamer's and the World Need Doers but
            above All the World Need Dreamer's Who Do.
          </p>
        </div>

        {/* =======================================================
            CATEGORY GRID
        ======================================================= */}

        <div
          style={{
            display: "grid",

            gridTemplateColumns:
              "repeat(4, minmax(0, 1fr))",

            gap: "22px",
          }}
        >
          {categories.map(
            (category, index) => (
              <Link
                key={index}
                to="#"
                style={{
                  textDecoration:
                    "none",

                  display:
                    "block",

                  minWidth: 0,
                }}
              >
                <div
                  style={{
                    position:
                      "relative",

                    height:
                      "270px",

                    overflow:
                      "hidden",

                    borderRadius:
                      "16px",

                    background:
                      "linear-gradient(145deg, rgba(255,255,255,0.055), rgba(255,255,255,0.015))",

                    border:
                      `1px solid ${category.accent}22`,

                    boxShadow:
                      "0 15px 40px rgba(0,0,0,0.32), inset 0 1px 0 rgba(255,255,255,0.025)",

                    transition:
                      "transform 0.35s ease, border-color 0.35s ease, box-shadow 0.35s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform =
                      "translateY(-8px)";

                    e.currentTarget.style.borderColor =
                      `${category.accent}70`;

                    e.currentTarget.style.boxShadow =
                      `0 20px 50px rgba(0,0,0,0.5), 0 0 25px ${category.accent}15`;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform =
                      "translateY(0)";

                    e.currentTarget.style.borderColor =
                      `${category.accent}22`;

                    e.currentTarget.style.boxShadow =
                      "0 15px 40px rgba(0,0,0,0.32), inset 0 1px 0 rgba(255,255,255,0.025)";
                  }}
                >
                  {/* =================================================
                      IMAGE
                  ================================================= */}

                  <img
                    src={category.img}
                    alt={category.title}
                    style={{
                      position:
                        "absolute",

                      inset: 0,

                      width: "100%",
                      height: "100%",

                      objectFit:
                        "cover",

                      display:
                        "block",

                      transition:
                        "transform 0.5s ease",

                      filter:
                        "brightness(0.72) saturate(0.9)",
                    }}
                    onMouseEnter={(
                      e
                    ) => {
                      e.currentTarget.style.transform =
                        "scale(1.07)";
                    }}
                    onMouseLeave={(
                      e
                    ) => {
                      e.currentTarget.style.transform =
                        "scale(1)";
                    }}
                  />

                  {/* =================================================
                      DARK IMAGE OVERLAY
                  ================================================= */}

                  <div
                    style={{
                      position:
                        "absolute",

                      inset: 0,

                      background:
                        "linear-gradient(180deg, rgba(3,6,12,0.05) 15%, rgba(3,6,12,0.25) 40%, rgba(3,6,12,0.94) 100%)",
                    }}
                  />

                  {/* =================================================
                      TOP CORNER GLOW
                  ================================================= */}

                  <div
                    style={{
                      position:
                        "absolute",

                      top: 0,
                      left: 0,
                      right: 0,

                      height: "2px",

                      background:
                        `linear-gradient(90deg, transparent, ${category.accent}, transparent)`,

                      boxShadow:
                        `0 0 12px ${category.accent}60`,
                    }}
                  />

                  {/* =================================================
                      CATEGORY NUMBER
                  ================================================= */}

                  <div
                    style={{
                      position:
                        "absolute",

                      top: "14px",
                      right: "15px",

                      width: "30px",
                      height: "30px",

                      display:
                        "flex",

                      alignItems:
                        "center",

                      justifyContent:
                        "center",

                      borderRadius:
                        "50%",

                      background:
                        "rgba(4,8,16,0.72)",

                      border:
                        `1px solid ${category.accent}45`,

                      color:
                        category.accent,

                      fontSize: "10px",

                      fontWeight: 800,

                      boxShadow:
                        `0 0 12px ${category.accent}15`,
                    }}
                  >
                    {String(
                      index + 1
                    ).padStart(2, "0")}
                  </div>

                  {/* =================================================
                      TITLE
                  ================================================= */}

                  <div
                    style={{
                      position:
                        "absolute",

                      left: 0,
                      right: 0,
                      bottom: 0,

                      padding:
                        "20px 18px",

                      zIndex: 3,
                    }}
                  >
                    <h6
                      style={{
                        margin: 0,

                        color:
                          "#ffffff",

                        fontSize:
                          "15px",

                        lineHeight:
                          1.4,

                        fontWeight:
                          700,

                        letterSpacing:
                          "0.15px",

                        textShadow:
                          "0 2px 12px rgba(0,0,0,0.95), 0 1px 4px rgba(0,0,0,0.9)",
                      }}
                    >
                      {
                        category.title
                      }
                    </h6>

                    {/* Small accent line */}

                    <div
                      style={{
                        width:
                          "38px",

                        height:
                          "2px",

                        marginTop:
                          "10px",

                        background:
                          category.accent,

                        boxShadow:
                          `0 0 10px ${category.accent}`,
                      }}
                    />
                  </div>
                </div>
              </Link>
            )
          )}
        </div>

        {/* =======================================================
            BOTTOM MESSAGE
        ======================================================= */}

        <div
          style={{
            display:
              "flex",

            justifyContent:
              "center",

            alignItems:
              "center",

            gap: "9px",

            marginTop:
              "42px",

            color:
              "#718096",

            fontSize:
              "10px",

            fontWeight: 700,

            letterSpacing:
              "1.8px",

            textTransform:
              "uppercase",
          }}
        >
          <span
            style={{
              width: "6px",
              height: "6px",

              borderRadius: "50%",

              background:
                "#00f6ff",

              boxShadow:
                "0 0 10px #00f6ff",
            }}
          />

          Learn • Grow • Succeed
        </div>
      </div>

      {/* =========================================================
          BOTTOM SCAN LINE
      ========================================================= */}

      <div
        style={{
          position:
            "absolute",

          bottom: 0,
          left: "10%",
          right: "10%",

          height: "1px",

          background:
            "linear-gradient(90deg, transparent, rgba(0,246,255,0.45), rgba(139,92,255,0.35), transparent)",
        }}
      />

      {/* =========================================================
          RESPONSIVE CSS
      ========================================================= */}

      <style>
        {`
          @media (max-width: 1100px) {
            .course-category-grid {
              grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
            }
          }

          @media (max-width: 768px) {
            .course-category-grid {
              grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
            }
          }

          @media (max-width: 500px) {
            .course-category-grid {
              grid-template-columns: 1fr !important;
            }
          }
        `}
      </style>
    </section>
  );
};

export default CourseCategoryList;